import React, { useState, useEffect } from 'react';
// import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb, Select, Button, Row, Col, Typography, Modal, Upload, Image, Space, message, Form, Input, Checkbox } from 'antd';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import axios from 'axios';
import DocumentViewer from '../../components/document-viewer/DocumentViewer';
import { CloudUploadOutlined, DownloadOutlined, SendOutlined, EyeOutlined, CheckOutlined } from '@ant-design/icons';
import ProcessingModal from '../../components/processing/ProcessingModal';
import moment from 'moment';
import SectionedFormRenderer from '../../components/utility/SectionedFormRenderer';
import uuid from 'react-uuid';

const { Option } = Select;
const { Text } = Typography;

export function OldStudentAdmission(props) {
   const [form] = Form.useForm();
   var subdomain = localStorage.getItem("lms-subdomain");
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   // const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);


   const [currentDocument, setCurrentDocument] = useState(null);
   const [selectedScheme, setSelectedScheme] = useState(null);
   const [paymentSchemes, setPaymentSchemes] = useState([]);
   // const [hasSelected, setHasSelected] = useState(false);
   // const [processed, setProcessed] = useState(false);

   const [selectedSOF, setSelectedSOF] = useState(null);
   const [sof, setSOF] = useState([]);

   // const [percentage, setPercentage] = useState(0);
   // const [isUploading, setIsUploading] = useState(false);
   // const [downloadStatus, setDownloadStatus] = useState(false);

   const [sectionedPIConfig, setSectionedPIConfig] = useState(null);
   const [updating, setUpdating] = useState(false);
   const [siUpdated, setSIUpdated] = useState(false);

   const [fileForUpload, setFileForUpload] = useState(null);
   const [pop, setPop] = useState(null);
   const [bankDetails, setBankDetails] = useState(null);
   const [studentInfo, setStudentInfo] = useState(null);
   const [conforme, setConforme] = useState(false);
   const [isSubmitted, setIsSubmitted] = useState(false);
   const [hasBackAccount, setHasBackAccount] = useState(false);

   const [previewModalVisible, setPreviewModalVisible] = useState(false);
   const [profileModalVisible, setProfileModalVisible] = useState(false);
   const [modalPoP, setModalPoP] = useState(false);
   const [modalConforme, setModalConforme] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      GetSOF(user_id);
   }, [user_id]);

   const GetSOF = (id) => {
      axios.get(`${process.env.REACT_APP_API_CPH}/getsof?id=${id}&st=old`).then((response) => {
         if (response.data) {
            const data = response.data;

            if (data !== null && data !== "") {
               if (data.length > 1)
                  setSOF(data);
               else {
                  setSelectedSOF(data[0].description);
                  setCurrentDocument(data[0].document);
               }
            }

            GetPaymentSchemes();
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const GetPaymentSchemes = () => {
      axios.get(`${process.env.REACT_APP_API_CPH}/v2/paymentschemes`).then((response) => {
         if (response.data) {
            const data = response.data;

            if (data !== null && data !== "") {
               setPaymentSchemes(data);
               getApplicationInfo(user_id);
            }
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleChange = (val) => {
      if (val !== "" && val !== undefined) {
         setSelectedScheme(val);
      }
   }

   // const upload_option = {
   //    onUploadProgress: (progressEvent) => {
   //       const { loaded, total } = progressEvent;
   //       let p = Math.floor((loaded * 100) / total)
   //       setPercentage(p)
   //    }
   // }

   // const handleUpload = (file) => {
   //    const formData = new FormData();
   //    formData.append('file', file);

   //    setPercentage(0);
   //    setIsUploading(true);

   //    var upload_url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_ONLINE_APPLICATION_PATH}/assessment-pop`;
   //    axios.post(upload_url, formData, upload_option).then(response => {
   //       console.log(response);
   //       if (response.data) {
   //          let data = response.data;

   //          var url = `${process.env.REACT_APP_API_CPH}/updatesafield?id=${user_id}&fn=tuition_assessment_pop&fv=${data}`;

   //          axios.post(url).then((response) => {
   //             if (response.data) {
   //                Modal.success({
   //                   title: 'Online Application',
   //                   content: 'Upload successfull.',
   //                   centered: true,
   //                });

   //                setIsUploading(false);
   //             }
   //          }, (error) => {
   //             setIsUploading(false);
   //             Modal.error({
   //                title: 'Online Application',
   //                content: error.response.data,
   //                centered: true
   //             });
   //          });
   //       }
   //    }, (error) => {
   //       console.log(error.message);
   //       setIsUploading(false);
   //       Modal.error({
   //          title: 'Online Application',
   //          content: error.response.data,
   //          centered: true
   //       });
   //    });
   // }

   // const UploadButton = () => {
   //    const props = {
   //       beforeUpload: file => {
   //          const isPNG = file.type === 'image/png';
   //          const isJPG = file.type === 'image/jpeg';
   //          const isBMP = file.type === 'image/bmp';
   //          const isPDF = file.type === 'application/pdf';

   //          const fileValid = isPNG || isJPG || isBMP || isPDF;

   //          if (fileValid) {
   //             const isLt100M = file.size / 1024 / 1024 <= 5;

   //             if (isLt100M) {
   //                handleUpload(file);
   //             } else {
   //                Modal.error({
   //                   title: 'Schedule',
   //                   content: 'File should be less than 5 MB',
   //                   centered: true
   //                });
   //             }
   //          } else {
   //             Modal.error({
   //                title: 'Schedule',
   //                content: 'You are not allowed to upload that file type',
   //                centered: true
   //             });
   //          }
   //       },
   //    };
   //    return (
   //       <Upload {...props} showUploadList={false}
   //          accept=".png,.jpg,.pdf,.bmp"
   //       >
   //          <Button className='button-shadow' type="primary" size="middle" shape='round'>
   //             <Text ellipsis style={{ color: "#fff" }}><CloudUploadOutlined />&nbsp;Upload Proof of Payment</Text>
   //          </Button>
   //       </Upload>
   //    );
   // };

   const handleSOFChange = (val) => {
      let _sof = [...sof];
      let result;
      _sof.forEach(item => {
         if (item.description === val) {
            result = item;
         }
      });

      setCurrentDocument(result.document);
      setSelectedSOF(result.description);
   }

   const handleUpload = async(file) => {
      try {
         const compressedBlob = await Utils.advancedImageCompress(file);

         const ext = compressedBlob.type.split("/")[1] || "jpg";
         const compressedFile = new File(
            [compressedBlob],
            file.name.replace(/\.[^/.]+$/, `${ext}`),
            {
               type: compressedBlob.type,
            }
         );

         console.log(
            `Original: ${(file.size / 1024).toFixed(2)} KB`
         );

         console.log(
            `Compressed: ${(compressedFile.size / 1024).toFixed(2)} KB`
         );

         const formData = new FormData();
         formData.append('file', compressedFile);

         setFileForUpload(formData);

         Utils.getBase64(compressedFile, (imageb64) => {
            setPop(imageb64);
         });
      } catch (error) {
         message.error("Image compression failed");
         return Upload.LIST_IGNORE;
      }
      
   };

   const beforeDocUpload = (file, doctype) => {
      var isValid = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';

      if (!isValid) {
         message.error('You can only upload JPG and PNG files.');
      }

      var isLt = file.size / 1024 / 1024 <= 5;
      if (!isLt) {
         message.error('Image must smaller than 5MB.');
      }

      if (isValid && isLt) {
         handleUpload(file, doctype);
      }
   }

   const downloadSOF = (url) => {
      Utils.downloadFile(url, `SOF_${moment().format("MM-DD-YYYY")}`).then(() => {
         // Modal.info({
         //    title: 'Online Application',
         //    content: "Download successful.",
         //    centered: true
         // });
         console.log("Download successful.");
      }).catch((error) => {
         console.log(error.message);

         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   };

   const handleViewDoc = (doc) => {
      setPreviewModalVisible(true);
   }

   const getFormSectionedFields = async (fn, si) => {
      var url = `${process.env.REACT_APP_API_CPH}/getsectionedfields?fn=${fn}&ft=full&m=edit`;

      try {
         const response = await axios.get(url);
         const data = response.data;

         setSectionedPIConfig(data);
         putFieldValues(data, si);
      } catch (error) {
         console.log(error.message);
      } finally {
         // setLoading(false);
      }
   };

   const getApplicationInfo = async (id) => {
      var url = `${process.env.REACT_APP_API_CPH}/studentprofile?id=${id}`;

      try {
         const response = await axios.get(url);
         const data = response.data;

         setStudentInfo(data);
         getFormSectionedFields(1, data);

         setSelectedScheme(data.selected_scheme);
         setIsSubmitted(data.selected_scheme !== null ? true : false);
         setHasBackAccount(data.with_back_accounts === null || data.with_back_accounts === 0 ? false : true);

         if (data.with_back_accounts !== null && data.with_back_accounts !== 0) {
            Modal.info({
               title: 'Notice',
               content: 'You have an outstanding balance. Please visit the Accounting Office at your earliest convenience.',
               centered: true,
            });
         }
      } catch (error) {
         console.log(error.message);
      } finally {

      }
   }

   const putFieldValues = (fields, data) => {
      var fieldValues = JSON.parse(data.OtherInfo);

      //-- If fieldValues is null, set its initial value from studentInfo
      if (fieldValues === null) {
         fieldValues = {
            "LRNNo": data.LRNNo,
            "FirstName": data.FirstName,
            "MiddleName": data.MiddleName,
            "LastName": data.LastName,
            "Sex": data.Sex,
            "BirthDate": data.BirthDate,
            // "PlaceofBirth": "",
            "MobileNo": data.MobileNo,
            // "ContactNo": "",
            "EmailAdd": data.EmailAdd,
         }
      }

      for (const sectionKey in fields) {
         const section = fields[sectionKey];
         for (const fieldKey in section.fields) {
            if (fieldKey.toLocaleLowerCase().includes("date")) {
               if (fieldValues[fieldKey] !== null)
                  form.setFieldValue(fieldKey, moment(fieldValues[fieldKey], 'YYYY-MM-DD'));
            }
            else {
               if (fieldValues[fieldKey] !== null)
                  form.setFieldValue(fieldKey, fieldValues[fieldKey]);
            }
         }
      }
   }

   const DoUpdateProfile = () => {
      // setUpdating(true);

      const formData = form.getFieldsValue();
      var other_data = {};

      // Get the other data field values
      for (const sectionKey in sectionedPIConfig) {
         const section = sectionedPIConfig[sectionKey];

         for (const fieldKey in section.fields) {
            if (fieldKey.toLocaleLowerCase().includes("date")) {
               other_data[fieldKey] = moment(formData[fieldKey]).format('YYYY-MM-DD');
            } else {
               other_data[fieldKey] = formData[fieldKey];
            }
         }
      }

      if (isSubmitted) {
         setUpdating(true);

         var student_data2 = {
            lrn_no: formData.LRNNo,
            lastname: formData.LastName,
            firstname: formData.FirstName,
            middlename: formData.MiddleName,
            gender: formData.Sex,
            dob: moment(formData.birth_date).format('YYYY-MM-DD'),
            email: formData.EmailAdd,
            mobileno: formData.ContactNo,
            other_info: JSON.stringify(other_data),
         }

         const url = `${process.env.REACT_APP_API_CPH}/updatestudentprofile?id=${user_id}`;
         axios.post(url, student_data2).then(response => {
            console.log(response);

            getApplicationInfo(user_id);

            Modal.success({
               title: 'Student Profile',
               content: 'Profile updated.',
               centered: true,
               onOk: () => setUpdating(false)
            });

         }, (error) => {
            // setUpdating(false);
            console.log(error.message);
            Modal.error({
               title: 'Student Profile',
               content: error.response.data,
               centered: true,
               onOk: () => setUpdating(false)
            });
         });
      }

      var student_data = {
         Id: `online_application_${uuid()}`,
         Lrn: formData.LRNNo,
         Last_name: formData.LastName,
         First_name: formData.FirstName,
         Middle_name: formData.MiddleName,
         Gender: formData.Sex,
         Birth_date: moment(formData.BirthDate).format('YYYY-MM-DD'),
         Email: formData.EmailAdd,
         Contact_number: formData.ContactNo,
         Other_info: JSON.stringify(other_data),
         Student_type: "old",
      }

      try {
         setStudentInfo(student_data);
         setSIUpdated(true);
         setProfileModalVisible(false);
      } catch (error) {
         Modal.error({
            title: 'Student Profile',
            content: 'Error updating student info.',
            centered: true,
         });
      }
   }

   const handleUpdate = () => {
      form.validateFields().then(() => {
         DoUpdateProfile();
      }).catch((error) => {
         console.log('Validation Error:', error);
         Modal.info({
            title: 'Student Profile',
            content: 'Please fill out all required fields.',
            centered: true
         });
      });
   }

   const handleShowProfile = () => {
      // if (studentInfo === null) {
      //    getApplicationInfo(user_id);
      // } else {
      //    putFieldValues(sectionedPIConfig, studentInfo);
      // }

      putFieldValues(sectionedPIConfig, studentInfo);

      setProfileModalVisible(true);
   }

   const handleSubmit = () => {
      //-- Validate the data
      const missingActions = [
         !pop && 'Proof of Payment',
         !bankDetails && 'Bank Details',
         !selectedScheme && 'Payment Terms',
         !currentDocument && 'Assessment Fees',
         !selectedSOF && 'Schedule of Fees',
         !siUpdated && 'Update Student Information',
         !conforme && 'Conforme',
      ].filter(Boolean);

      if (missingActions.length > 0) {
         Modal.info({
            title: 'Online Admission',
            content: (
               <>
                  Please complete the following:
                  <ul>{missingActions.map((doc, i) => <li key={i}>{doc}</li>)}</ul>
               </>
            ),
            centered: true,
         });
         return;
      }

      setUpdating(true);

      var upload_url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_ONLINE_APPLICATION_PATH}/assessment-pop`;
      axios.post(upload_url, fileForUpload).then(response => {
         console.log(response);
         if (response.data) {
            let path = response.data;

            var url = `${process.env.REACT_APP_API_CPH}/admitoldstudent?id=${user_id}`;

            var additionalData = {
               Tuition_assessment_scheme: selectedScheme,
               Tuition_assessment_pop: path,
               Tuition_assessment_terms: currentDocument,
               sof: selectedSOF,
               Bank_details: bankDetails
            }

            var studentData = { ...studentInfo, ...additionalData };

            axios.post(url, studentData).then((response) => {
               if (response.data) {

                  setUpdating(false);

                  Modal.success({
                     title: 'Online Application',
                     content: 'Submission successful.',
                     centered: true,
                     onOk: GetSOF(user_id),
                  });
               }
            }, (error) => {
               setUpdating(false);

               Modal.error({
                  title: 'Online Application',
                  content: error.response.data,
                  centered: true
               });
            });
         }
      }, (error) => {
         console.log(error.message);
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all application-page">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <Breadcrumb separator=">">
                     <Breadcrumb.Item>
                        Online Admission
                     </Breadcrumb.Item>
                  </Breadcrumb>
               </div>
               <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "10px", width: "100%" }}>
                  {
                     (sof.length > 1 && studentInfo !== null) &&
                     <div>
                        <Text>Schedule of Fees</Text>&nbsp;&nbsp;
                        <Select
                           key={'uid' + user_id}
                           showArrow
                           disabled={isSubmitted || hasBackAccount ? true : false}
                           size='middle'
                           style={{ minWidth: "300px" }}
                           allowClear
                           onChange={(val) => handleSOFChange(val)}
                        >
                           {sof.map(({ id, document, description }) => {
                              return <Option value={description}>{description}</Option>
                           })}
                        </Select>&nbsp;&nbsp;
                     </div>
                  }
                  {
                     (paymentSchemes.length > 0 && studentInfo !== null) &&
                     <div>
                        <Text>{isSubmitted ? "Selected Payment Terms" : "Select Payment Terms"}</Text>&nbsp;&nbsp;
                        <Select
                           key={'uid' + user_id}
                           showArrow
                           disabled={isSubmitted || hasBackAccount ? true : false}
                           size='middle'
                           style={{ minWidth: "200px" }}
                           onChange={(val) => handleChange(val)}
                           defaultValue={studentInfo.selected_scheme}
                        >
                           {paymentSchemes.map(({ scheme }) => {
                              return <Option value={scheme}>{scheme}</Option>
                           })}
                        </Select>
                        &nbsp;&nbsp;
                        <Button type="default" size="middle" shape='round' disabled={isSubmitted || hasBackAccount ? true : false} onClick={() => setModalPoP(true)}>Proof of Payment</Button>
                        &nbsp;&nbsp;
                        <Button type="default" size="middle" shape='round' onClick={() => handleShowProfile()}>Student Information</Button>
                     </div>
                  }
               </div>
               {
                  (paymentSchemes.length > 0 && studentInfo !== null) &&
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                     <div style={{ width: "60%" }}>
                        <DocumentViewer
                           document={currentDocument}
                           documentlist={null}
                           pdfshowdownload={true}
                           pdfshowprint={true}
                           dvheight={"calc(100vh - 150px)"}
                           emptydescription={'Assessment Fees not yet available'}
                        />
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", paddingTop: "10px" }}>
                           <Button type='default' shape='round' onClick={() => downloadSOF(`${currentDocument}`)}><DownloadOutlined />{"Download SOF"}</Button>&nbsp;&nbsp;
                           <div>
                              <Button type='default' shape='round' disabled={isSubmitted || hasBackAccount ? true : false} onClick={() => setModalConforme(true)}><CheckOutlined />{"Conforme"}</Button>&nbsp;&nbsp;
                              <Button className='button-shadow' type='primary' shape='round' disabled={isSubmitted || hasBackAccount ? true : false} onClick={() => handleSubmit()}><SendOutlined />{"Submit"}</Button>
                           </div>
                        </div>
                     </div>
                  </div>
               }

            </div>
         </div>

         <Modal
            key='preview-doc'
            title={"Preview "}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={previewModalVisible}
            width='75%'

            onCancel={() => { setPreviewModalVisible(false); }}
            onOk={() => { setPreviewModalVisible(false); }}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               <div
                  className={'modal-document-viewer'}
                  style={{ height: "calc(100vh - 195px)" }}
               >
                  <Image
                     src={pop}
                     style={{ minHeight: "calc(100vh - 195px)", maxHeight: "calc(100vh - 195px)" }}
                  />
               </div>
            </div>
         </Modal>

         <Modal
            title={"Student Information"}
            centered
            destroyOnClose={true}
            onCancel={() => { setProfileModalVisible(false); }}
            open={profileModalVisible}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText={'Close'}
            width='75%'
            style={{ minWidth: '400px' }}
            footer={[
               <Row gutter={[12, 12]}>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ display: "flex", justifyContent: "right" }}>
                     <Button type='default' onClick={() => setProfileModalVisible(false)} shape='round'>Cancel</Button>
                     <Button type='primary' onClick={handleUpdate} shape='round' htmlType="submit">Update</Button>
                  </Col>
               </Row>
            ]}
         >
            {
               studentInfo !== null &&
               <div style={{ maxHeight: "calc(100vh - 180px)", width: '99%', overflow: 'auto' }}>
                  <Form
                     form={form}
                     autoComplete="off"
                     layout='vertical'
                     style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px' }}
                  >
                     {
                        sectionedPIConfig !== null &&
                        <>
                           <SectionedFormRenderer sectionedFormConfig={sectionedPIConfig} form={form} />
                        </>
                     }
                  </Form>
               </div>
            }
         </Modal>

         <Modal
            key="modal-pop"
            title='Upload Proof of Payment'
            destroyOnClose={true}
            centered
            okText={"Ok"}
            cancelText={"Close"}
            open={modalPoP}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round", style: { display: 'none' } }}
            onOk={() => setModalPoP(false)}
            onCancel={() => setModalPoP(false)}
         >
            <Space direction="vertical" style={{ width: "100%", textAlign: "left" }}>
               <div>
                  <Text>Enter Bank Details</Text>&nbsp;&nbsp;
                  <Input id={'bank_details'} name={'bank_details'} style={{ borderRadius: '7px' }} onChange={(e) => setBankDetails(e.target.value)} defaultValue={bankDetails} />
               </div>
               <div>
                  {
                     studentInfo !== null &&
                     !studentInfo.pop_validated &&
                     <>
                        <Upload beforeUpload={(file) => { beforeDocUpload(file, 'pop') }} showUploadList={false} accept=".jpg, .png, .bmp" >
                           <Button type="default" size="middle" shape='round'>
                              <CloudUploadOutlined />&nbsp;Upload
                           </Button>
                        </Upload>
                     </>
                  }
                  &nbsp;&nbsp;
                  {
                     pop !== null &&
                     <Button type="default" size="middle" shape='round' onClick={() => handleViewDoc(pop)}><EyeOutlined /></Button>
                  }
               </div>
            </Space>
         </Modal>

         <Modal
            key="modal-conforme"
            title='Conforme'
            destroyOnClose={true}
            centered
            okText={"Ok"}
            cancelText={"Close"}
            open={modalConforme}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round", style: { display: 'none' } }}
            onOk={() => setModalConforme(false)}
            onCancel={() => setModalConforme(false)}
         >
            <Space direction="vertical" style={{ width: "100%", textAlign: "left" }}>
               <Space direction="vertical" style={{ width: "100%", textAlign: "justify", backgroundColor: "#fff", padding: "10px", borderRadius: "7px" }}>
                  <Text>
                     In accordance with the financial policies of the school as set out in the Student Diary, the failure to meet the financial obligation to the school within the specified period may result in the withholding of transfer credentials, deprivation of any quarterly of final examinations, refusal of re-admission, dropping from the rolls and availment of the other applicable remedies.
                  </Text>
                  <Text>
                     *If check payment, write payee as Don Bosco Technical Institute of Makati, Inc. and write name of student and contact no. at the back of the check.
                  </Text>
                  <Text>
                     *Failure to pay on the due date will be subjected to a penalty of 5% of the total amount due.
                  </Text>
               </Space>
               <div style={{ display: "flex", alignItems: "left", justifyContent: "center" }}>
                  <Checkbox
                     name={props.id}
                     checked={conforme}
                     onChange={() => setConforme(!conforme)}>I have read and understand the registration and assessment form and agree with the conditions stipulated.</Checkbox>
               </div>
            </Space>
         </Modal>

         {/* <Modal
            key="modal-bank-account"
            title='Bank Account'
            destroyOnClose={true}
            centered
            okText={"Ok"}
            cancelText={"Close"}
            open={hasBackAccount}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round", style: { display: 'none' } }}
            onOk={() => setHasBackAccount(false)}
            onCancel={() => setHasBackAccount(false)}
         >
            <Space direction="vertical" style={{ width: "100%", textAlign: "left" }}>
               <Text>
                  You have an outstanding balance.
                  Please visit the Accounting Office at your earliest convenience.
               </Text>
            </Space>
         </Modal> */}
      </>
   );
}
